export enum ProfileState {
  STEP1 = 'profile_incomplete',
  STEP2 = 'profile_completed',
}
